module.exports = __webpack_public_path__ + "img/team.75c6c10b.svg";